//All pages
(function ($) {
  var windowObj = $(window); //window cached in var for performance
  var axiomBody = $('body'); //body cached in var for performance
  var documentObj = $(document);
  /***
  ********
  ****
  Smooth Scrolling Function (redunant due to hashHandler()?)
  ****
  ********
  ***/
  function smoothScrolling() {
    $('a[href*=\\#]:not([href=\\#],[href="\\#0"],.no-smooth-scroll)').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

        let offset = (window.innerWidth < 992 ? 30 : 50);
        offset += document.querySelector('.site-header__navbar').offsetHeight;
        offset += (document.body.classList.contains('admin-bar') ? document.getElementById('wpadminbar').offsetHeight : 0);

        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top - offset
          }, 1000);
          return false;
        }
      }
    });
  }
  smoothScrolling();
  /***
  ********
  ****
  Return to top anchor
  ****
  ********
  ***/
  function returnTop() {
    var returnTop = $('.return-to-top');
    var returnTopAlt = $('.return-to-top-alt');
    windowObj.scroll(function() {
      if ($(this).scrollTop() >= 50) {
        returnTop.fadeIn(200);
      } else {
        returnTop.fadeOut(200);
      }
    });
    returnTop.on('click', function(){
      $('body,html').animate({
        scrollTop : 0
      }, 500);
    });
    returnTopAlt.on('click', function(){
      $('body,html').animate({
        scrollTop : 0
      }, 500);
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  axiom Navbar Functionality
  ****
  ********
  ***/
  function axiomNavbar() {
    var siteHeader = $('.site-header');
    //shrink navbar on scroll
    windowObj.scroll(function() {
      if ($(document).scrollTop() > 0) {
        siteHeader.addClass('site-header--shrink');
      }
      else {
        siteHeader.removeClass('site-header--shrink');
      }
    });
    //if transparent, add extra padding to next element
    if (siteHeader.hasClass('site-header--transparent')) {
      var siteHeaderHeight = $('.site-header__navbar').outerHeight();
      var target = siteHeader.next().not('.axiom-banner');

      if(target.data('nav-offset-type') != null && target.data('nav-offset-type') === 'margin'){
        target.css('margin-top', siteHeaderHeight); // removed + 30 for now so the nav blue line lines up
      }else{
        target.css('padding-top', siteHeaderHeight); // removed + 30 for now so the nav blue line lines up
      }
    }
    //if dropdown clicked, shrink nav to add solid bg and make look better
    $('.dropdown-toggle').click(function(){
      // var el = $(this);
      // el.closest('li').toggleClass('show');
      // el.next('.dropdown-menu').toggleClass('show');
      // console.log('test');
      siteHeader.addClass('site-header--shrink');
    });
    //if navbar mobile toggle clicked, shrink nav to solidify background when transparent
    $('.site-header__nav-toggle').click(function(){
      siteHeader.addClass('site-header--shrink');
    });
  }
  axiomNavbar();
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  GDPR Consent Bar Functionality
  ****
  ********
  ***/
  function gdprConsent() {
    var gdprConsentBar = $('.gdpr-consent');
    windowObj.scroll(function() {
      if (documentObj.scrollTop() > 70) {
        gdprConsentBar.addClass('gdpr-hidden animated');
      }
      else {
        gdprConsentBar.removeClass('gdpr-hidden animated');
      }
    });

    $('.gdpr-give-consent').click(function(event){
      event.preventDefault();
      Cookies.remove('axiom_gdpr_consent_undecided');
      Cookies.set('axiom_gdpr_consent', 1, { expires: 365, path: '/' });
      gdprConsentBar.hide();
      //$('.gdpr-consent__accepted-notice').addClass('show-accepted-message animated');
    });

    $('.gdpr-close').click(function(event){
      gdprConsentBar.addClass('gdpr-hidden animated');
      setTimeout(function() { gdprConsentBar.remove(); }, 2000);
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  axiom Accordion Functionality
  ****
  ********
  ***/
  function axiomAccordions() {
    $('.accordion__title').each(function() {
      var accordion = $(this), state = false, accordionContent = accordion.next('.accordion__content').hide().css('height','auto').slideUp();
      accordion.click(function() {
        state = !state;
        accordionContent.slideToggle(state);
        accordion.parent().toggleClass('accordion-open',state);
      });
    });
  }
  axiomAccordions();
  /***
  ********
  ****
  Nav Tabs Opening From URL Hashes
  ****
  ********
  ***/
  function navTabUrls() {
    // Show appropriate pill based on #anchor in URL
    var url = window.location.href;
    if (url.indexOf("#") > 0){
      var activeTab = url.substring(url.indexOf("#") + 1);
      $('.nav-tabs a[href="#'+activeTab+'"]').tab('show');
    }
  }
  navTabUrls();
  /***
  ********
  ****
  Remove Collapse Trigger On Click
  ****
  ********
  ***/
  function removeCollapseTrigger() {
    $('.hide-me-onclick').click(function(e){
      e.preventDefault();
      $(this).hide();
    });
  }
  removeCollapseTrigger();
  /***
  ********
  ****
  axiom Content Manipulation
  ****
  ********
  ***/
  /*function axiomContentManipulation() {
    $('p:empty').remove();
  }
  axiomContentManipulation();*/
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Bootstrap Fixes
  ****
  ********
  ***/
  function axiomBootstrapBugFixes() {
    $('.carousel-control-next').click(function(e){
      e.preventDefault();
      var carousel = $(this).attr('href');
      $(carousel).carousel('next');
    });
    $('.carousel-control-prev').click(function(e){
      e.preventDefault();
      var carousel = $(this).attr('href');
      $(carousel).carousel('prev');
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  axiom Slider
  ****
  ********
  ***/
  function axiomBackgroundSlider() {
    var backgroundCarousel = $('.axiom-banner__slideshow');
    if (backgroundCarousel != null) {
      var options = {
        accessibility: true,
        prevNextButtons: true,
        pageDots: false,
        setGallerySize: false,
        autoPlay: 8000,
        pauseAutoPlayOnHover: false,
        setGallerySize: false,
        ImagesLoaded: true,
        // wrapAround: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15
        }
      };

      var carousel = document.querySelector('.axiom-banner__slideshow');
      var slides = document.getElementsByClassName('carousel-cell');
      var flkty = new Flickity(carousel, options);

      flkty.on('scroll', function () {
        flkty.slides.forEach(function (slide, i) {
          var image = slides[i];
          var x = (slide.target + flkty.x) * -1/3;
          image.style.backgroundPosition = x + 'px';
        });
      });

      flkty.on('staticClick', function(event, pointer, cellElement, cellIndex) {
        flkty.playPlayer();
      });

      $('.flickity-page-dots').find('.dot').prepend('<span class="circle-animation"><svg height="25" width="25"><circle cx="12" cy="12" r="10" stroke-width="3" fill="none" /></svg></span>');
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Accreditations carousel on sm
  ****
  ********
  ***/
  function accreditationsCarousel() {
    var accreditationsCarousel = $('.accreditations__wrap');
    if (windowObj.width() < 992 && accreditationsCarousel != null) {
      $('.accreditations__wrap').flickity({
        // options
        contain: true,
        pageDots: false,
        watchCSS: true,
        adaptiveHeight: true,
        imagesLoaded: true,
        autoPlay: true,
        // wrapAround: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15
        }
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Tabbed Content Carousel
  ****
  ********
  ***/
  function tabbedCarousel() {
    var tabbedCarousel = $('.tabbed-carousel__carousel-main');
    if (tabbedCarousel != null) {
      var $tabbedCarouselMain = $('.tabbed-carousel__carousel-main').flickity({
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
      });
      $tabbedCarouselMainData = $tabbedCarouselMain.data('flickity');
      //non visible cell click select
      $tabbedCarouselMain.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
        if ( typeof cellIndex == 'number' ) {
          $tabbedCarouselMain.flickity( 'selectCell', cellIndex );
        }
      });
      // elements
      var $cellButtonGroup = $('.tabbed-carousel__button-group--cells');
      var $cellButtons = $cellButtonGroup.find('.tabbed-carousel__page-dot');

      // update selected cellButtons
      $tabbedCarouselMain.on( 'select.flickity', function() {
        $cellButtons.filter('.tabbed-carousel__page-dot--is-selected')
          .removeClass('tabbed-carousel__page-dot--is-selected');
        $cellButtons.eq( $tabbedCarouselMainData.selectedIndex )
          .addClass('tabbed-carousel__page-dot--is-selected');
      });

      // select cell on button click
      $cellButtonGroup.on( 'click', '.tabbed-carousel__page-dot', function() {
        var index = $(this).index();
        $tabbedCarouselMain.flickity( 'select', index );
      });
      // previous
      $('.tabbed-carousel__button--previous').on( 'click', function() {
        $tabbedCarouselMain.flickity('previous');
      });
      // next
      $('.tabbed-carousel__button--next').on( 'click', function() {
        $tabbedCarouselMain.flickity('next');
      });

      //nav for main carousel
      var tabbedCarouselNav = $('.tabbed-carousel__carousel-nav').flickity({
        asNavFor: '.tabbed-carousel__carousel-main',
        pageDots: false,
        freeScroll: true,
        contain: true,
        groupCells: true,
        prevNextButtons: false,
        cellAlign: 'center',
      });

      tabbedCarouselNav.on('dragEnd.flickity', function( event, pointer ){
        var navIndex = tabbedCarouselNav.find('.carousel-cell.is-selected').index()
        $tabbedCarouselMain.flickity( 'selectCell', navIndex );
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Categorised Content Carousel
  ****
  ********
  ***/
  function categorisedCarousel() {
    var categorisedCarousel = $('.categorised-carousel');
    if (categorisedCarousel != null) {
      // initialise carousel
      var $categorisedCarouselMain = $('.categorised-carousel__carousel-main').flickity({
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
      });

      // update selected cellButtons
      $('.categorised-carousel__carousel-main').on( 'select.flickity', function() {
        let el = $(this);
        let buttons = getCategoryButtons(el);

        buttons.filter('.categorised-carousel__page-dot--is-selected')
          .removeClass('categorised-carousel__page-dot--is-selected');
        buttons.eq( el.data('flickity').selectedIndex )
          .addClass('categorised-carousel__page-dot--is-selected');
      });

      // select cell on button click
      $('.categorised-carousel__button-group--cells').on( 'click', '.categorised-carousel__page-dot', function() {
        let el = $(this);
        getCategoryMain(el).flickity('select', el.index());
      });

      // previous
      $('.categorised-carousel__button--previous').on( 'click', function() {
        getCategoryMain($(this)).flickity('previous');
      });

      // next
      $('.categorised-carousel__button--next').on( 'click', function() {
        getCategoryMain($(this)).flickity('next');
      });

      // tab change listeners
      $('.categorised-carousel__nav').on('click', '.categorised-carousel__nav__item', function(){
        let el = $(this);
        el.closest('.categorised-carousel').find('.active').removeClass('active');
        el.addClass('active');
        $(el.data('target')).addClass('active').find('.categorised-carousel__carousel-main').flickity('select', 0).flickity('resize');
        return false;
      });

      // function that selects the category and slide for solutions page
      function hashHandler(){
        let the_hash = window.location.hash;
        if(the_hash != ''){
          // get parts
          let parts = the_hash.match(/#([0-9]*)\-([0-9]*)/);

          let offset = (window.innerWidth < 992 ? 30 : 50);
          offset += document.querySelector('.site-header__navbar').offsetHeight;
          offset += (document.body.classList.contains('admin-bar') ? document.getElementById('wpadminbar').offsetHeight : 0);

          // if found string that matches
          if(parts != null){
            $('.categorised-carousel__nav__item').removeClass('active').filter('.categorised-carousel__nav__item--' + parts[1]).addClass('active');
            $('.categorised-carousel__category').removeClass('active').filter('.categorised-carousel__category--' + parts[1]).addClass('active').find('.categorised-carousel__carousel-main').flickity('resize').flickity('select', parts[2]);
            if ($('.categorised-carousel__nav__item').length) {
              $('html,body').animate({
                scrollTop: $('.categorised-carousel__nav__item').offset().top - offset
              }, 1000);
            }
          }else{
            let target = $(the_hash);
            if (target != null && target.length > 0) {
              target = target.length ? target : $('[name=' + target.slice(1) +']');

              if (target.length) {
                $('html,body').animate({
                  scrollTop: target.offset().top - offset
                }, 1000);
                return false;
              }
            }
          }
        }
      }
      // on pageload
      hashHandler();
      // run whenever hash changes as well
      window.addEventListener('hashchange', function() {
        hashHandler();
      }, false);



      // utility functions
      function getCategoryMain(el){
        return el.closest('.categorised-carousel__category').find('.categorised-carousel__carousel-main')
      }
      function getCategoryButtons(el){
        return el.closest('.categorised-carousel__category').find('.categorised-carousel__page-dot')
      }

      //nav for main carousel
      /*
      var categorisedCarouselNav = $('.categorised-carousel__carousel-nav').flickity({
        asNavFor: '.categorised-carousel__carousel-main',
        pageDots: false,
        freeScroll: true,
        contain: true,
        groupCells: true,
        prevNextButtons: false,
        cellAlign: 'center',
      });

      categorisedCarouselNav.on('dragEnd.flickity', function( event, pointer ){
        var navIndex = categorisedCarouselNav.find('.carousel-cell.is-selected').index()
        $categorisedCarouselMain.flickity( 'selectCell', navIndex );
      });
      */
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Animated Sections
  ****
  ********
  ***/
  function animateSections() {
    $('section, .bg-logo').each(function() {
      var vBlock = new Waypoint.Inview({
        element: this,
        enter: function(direction) {
          $(this.element).addClass('in-view');
        },
        offset: 50
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Carousel as nav
  ****
  ********
  ***/
  function navAsCarousel() {
    var categorisedCarouselNav = $('.categorised-carousel__nav');
    if (categorisedCarouselNav != null) {
      $('.categorised-carousel__nav').flickity({
        // options
        cellAlign: 'center',
        //wrapAround: true,
        groupCells: true,
        contain: true,
        autoPlay: true,
        pageDots: false,
        prevNextButtons: true
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Animated Border Text
  ****
  ********
  ***/
  function animateBorderText() {
    $('[class*="__border-text"]').each(function() {
      var vBlock = new Waypoint.Inview({
      element: this,
      entered: function(direction) {
        $(this.element).addClass('animated');
      },
      offset: 100 // ADDED, NOTHING CHANGED
      // Removed by Hodaka 2020/08/23. I don't think it should animate multiple times
      // ,
      // exited: function(direction) {
      //   $(this.element).removeClass('animated');
      // },
      });
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Animated Progress Bar
  ****
  ********
  ***/
  function progressBarInView() {
    $('.progress').each(function() {
      var vBlock = new Waypoint.Inview({
        element: this,
        entered: function(direction) {
          $(this.element).addClass('in-view');
        }
        // Removed by Hodaka 2020/08/23. I don't think it should animate multiple times
        // ,
        // exited: function(direction) {
        //   $(this.element).removeClass('in-view');
        // }
      });
    });
    //ensure lazyloaded/cropped imagery will function correctly with animations
    if ($('.flickity-enabled') != null) {
      $('.flickity-enabled').each(function() {
        var vBlock = new Waypoint.Inview({
          element: this,
          enter: function(direction) {
            /*$(this.element).on( 'ready.flickity', function() {
              $(this.element).flickity('reloadCells');
            });*/
            $(this.element).flickity('reloadCells');
          },
          offset: 50
        });
      });
    }
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Read more slide down
  ****
  ********
  ***/
  function readMoreSlideDown() {
    $('.slide-down-toggle').on('click', function(e) {
      e.preventDefault();
      $('.slide-down-content').slideToggle('fast');
        var $this = $(this);
        $this.toggleClass('open');
        if ($this.hasClass('open')) {
          $this.html('Close');
        }
        else {
          if ($('.slide-down-toggle').hasClass('reveal-jobs')) {
            $this.html('View Jobs');
          }
          else {
            $this.html('Read more');
          }
        }
    });
  }
  /******* Executed in document ready at end of file *******/
  function resourcesArchiveNav() {
    var resourcesArchiveNav = $('.archive-resources__post-navigation__slideshow');
    if (resourcesArchiveNav != null) {
      var $resourcesNav = $('.archive-resources__post-navigation__slideshow').flickity({
        pageDots: false,
        freeScroll: true,
        contain: true,
        groupCells: true,
        prevNextButtons: true,
        cellAlign: 'center',
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 60,
          y2: 45,
          x3: 15
        }
      });
    }
  }

  /***
  ********
  ****
  FacetWP page load nav selector
  Hides any pills if they have 0 results, as this causes issues
  ****
  ********
  ***/
  function facetPageLoadNavSelector() {

    let resource_type = getParameterByName('_resource_type');

    if(resource_type != null){
      $('.archive-resources__post-navigation__post').removeClass('archive-resources__post-navigation__post--active');
      $('.archive-resources__post-navigation__post').filter('[data-facet-value=' + resource_type + ']').addClass('archive-resources__post-navigation__post--active');
    }

  }
  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  /***
  ********
  ****
  FacetWP Hide Nav
  Hides any pills if they have 0 results, as this causes issues
  ****
  ********
  ***/
  function facetHideNav() {

    // cache
    let postNav = $(".archive-resources__post-navigation__post");
    let resource_facets = $('.facetwp-facet-resource_type').find('.facetwp-radio');

    if(resource_facets.length != 0){

      // for each resource facet
      resource_facets.each(function(){
        let data_value = $(this).data('value');
        if (data_value != '') postNav.filter('[data-facet-value=' + data_value + ']').show();
      });

      // also show all
      postNav.filter('[data-facet-value=all]').show();

      $('.archive-resources__post-navigation__slideshow').flickity('resize');
    }else{
      setTimeout(facetHideNav, 100);
    }
  }
  /***
  ********
  ****
  FacetWP Radio Buttons
  ****
  ********
  ***/
  function facetClicks() {
    let postNav = $(".archive-resources__post-navigation__post");
    let postNavActiveClass = 'archive-resources__post-navigation__post--active';
    postNav.on('click', function() {
      let el = $(this);
      postNav.removeClass(postNavActiveClass);
      el.addClass(postNavActiveClass);
      let resourceType = el.data('facet-value');
      console.log(resourceType);
      if (resourceType == 'all') {
        FWP.reset();
      }
      else {
        // FWP.refresh();
        $('.facetwp-radio').removeClass('checked');
        $('.facetwp-facet-resource_type').find("[data-value='" + resourceType + "']").addClass('checked');
        FWP.facets['resource_type'] = [resourceType];
        FWP.fetch_data();
      }
    });
  }
  /******* Executed in document ready at end of file *******/
  /***
  ********
  ****
  Vendor
  ****
  ********
  ***/
  function isotopeInit() {
    var $grid = $('.axiom-isotope-list').imagesLoaded( function() {
      $grid.isotope({
        // options
        itemSelector: '.axiom-isotope-item',
        layoutMode: 'fitRows'
      });
    });
    //filter items on button click
    $('.blog-listing__category-nav').on( 'click', '.blog-listing__category-nav__nav-link', function() {
      var filterValue = $(this).attr('data-filter');
      $grid.isotope({ filter: filterValue });
      $('.blog-listing__category-nav a').removeClass('is-selected');
      $(this).addClass('is-selected');
    });
  }
  /******* Executed in document ready at end of file *******/
  //mediabox video modals
  MediaBox('.mediabox');
  //match height of grouped elements
  $('.matchHeight').matchHeight();
  //bootstrap popovers
  $('.axiom-popover').popover();

  function hoverMenu(){

		let mainMenu = $('#menu-primary-navigation');
    let site_header = $('.site-header__navbar');

		mainMenu.find('.menu-item').each(function() {
      let el = $(this);

			el.on('mouseenter', function(){
				if(window.innerWidth > 992){
					el.find('> .nav-link, > .dropdown-item').addClass('show');
					el.find('> .dropdown-menu').addClass('show');
				}
			}).on('mouseleave', function(){
				if(window.innerWidth > 992){
					el.find('.nav-link, .dropdown-item').removeClass('show');
					el.find('.dropdown-menu').removeClass('show');
				}
			});
		});

		mainMenu.find('.nav-link, .dropdown-item').each(function() {
			let el = $(this);
			let elParent = el.closest('li');

			el.on('click', function(e){
				e.stopPropagation();

				if(window.innerWidth < 992 && el.next('.dropdown-menu').length === 1){
					if(elParent.hasClass('show')){
						if(el.attr('href') !== '#'){
							return true;
						}
						elParent.removeClass('show');
						elParent.find('li').removeClass('show');
						elParent.find('.dropdown-menu').removeClass('show');
					}else{
						elParent.addClass('show');
						el.next('.dropdown-menu').addClass('show');
					}
					return false;
				}
			});
		});
  }
  /***
  ********
  ****
  Functions which require document to be ready
  ****
  ********
  ***/
  $(function() {
    returnTop();
    gdprConsent();
    axiomBootstrapBugFixes();
    axiomBackgroundSlider();
    accreditationsCarousel();
    tabbedCarousel();
    categorisedCarousel();
    animateSections();
    animateBorderText();
    progressBarInView();
    isotopeInit();
    readMoreSlideDown();
    resourcesArchiveNav();
    facetPageLoadNavSelector();
    facetHideNav();
    facetClicks();
    hoverMenu();
    navAsCarousel();
  });

  // facet wp listener
  $(document).on('facetwp-loaded', function() {
      $.each(FWP.settings.num_choices, function(key, val) {
          var $parent = $('.facetwp-facet-' + key).closest('.facetwp__filter');
          (0 === val) ? $parent.hide() : $parent.show();
      });
  });
})(jQuery); // Fully reference jQuery after this point.
